import api from "./api";


export const getApiKeys = (params = {}) => api.get("/api-key/requests", { params });

export const addApiKey = (payload) => api.post("/api-key/request", payload);

export const revokeApiKey = (ip_address) => api.delete(`/api-key/ip/${ip_address}`);
